const defaultBranchFieldName = 'reward_form_submission[submission_data][branch_id]';

const branchMessages = {
  noCity: 'Pilih Kabupaten/Kota terlebih dahulu untuk melihat cabang tersedia.',
  noBranch: 'Cabang belum tersedia untuk Kabupaten/Kota yang dipilih.',
  loading: 'Memuat cabang...',
  error: 'Gagal memuat cabang. Silakan coba lagi.'
};

export function initBranchRadioFilters({ saveValueToCookies, loadValueFromCookies }) {
  const handleRadioCookieChange = function () {
    saveValueToCookies(this.name, this.value);
  };

  const bindRadioCookiePersistence = ($elements) => {
    $elements.off('change.branchCookie').on('change.branchCookie', handleRadioCookieChange);
  };

  const buildBranchCardElement = function(branch, index, fieldName, userGroupSerialSource) {
    const branchId = branch[userGroupSerialSource || 'userGroupSerial'] || branch['tag'];
    const sanitizedInputId = `option-${fieldName.replace(/[^a-z0-9]/gi, '_')}-${index}`;
    const $card = $('<div>').addClass('form-check');
    const $input = $('<input>', {
      type: 'radio',
      name: fieldName,
      value: branchId,
      id: sanitizedInputId,
      class: 'form-check-input branch-radio-card__input',
      'data-label-type': 'radio',
      'data-branch-city': branch['city'],
      'data-branch-district': branch['district'],
      'data-branch-province': branch['province'],
      'data-branch-city-serial': branch['citySerial']
    });
    const $label = $('<label>', { class: 'form-check-label branch-radio-card__label', for: sanitizedInputId });
    const $info = $('<div>').addClass('branch-radio-card__info');
    const branchName = branch['displayName'] || branch['branchName'];
    $info.append($('<div>').addClass('branch-radio-card__title').text(branchName));
    const locationLines = [];
    if (branch['address']) {
      locationLines.push(branch['address']);
    }
    locationLines.forEach((line) => {
      $info.append($('<div>').addClass('branch-radio-card__address').text(line));
    });
    const mapHref = branch['mapUrl'];
    if (mapHref) {
      const $mapLink = $('<a>', {
        class: 'branch-radio-card__map',
        href: mapHref,
        target: '_blank',
        rel: 'noreferrer noopener'
      }).text('Lihat Peta');
      $info.append($('<div>').addClass('branch-radio-card__map-link').append($mapLink));
    }
    $label.append($info);
    $card.append($input, $label);
    return $card;
  };

  const parseBranchResponse = function(response) {
    if (!response) return [];
    if (Array.isArray(response.branches)) return response.branches;
    if (Array.isArray(response.list)) return response.list;
    if (Array.isArray(response.data)) return response.data;
    return [];
  };

  const branchGroupControllers = [];

  $('.branch-radio-group').each(function() {
    const $group = $(this);
    const branchFieldName = $group.data('branch-field-name') || defaultBranchFieldName;
    const cityFieldName = $group.data('branch-city-field');
    if (!cityFieldName) {
      return;
    }

    const $cityField = $(`[name="${cityFieldName}"]`);
    if (!$cityField.length) {
      return;
    }

    const $message = $group.find('.branch-radio-empty');
    const $list = $group.find('.branch-radio-list');

    const showMessage = function(text, variant = 'default') {
      if (text) {
        $message.text(text);
        $message.show();
        $message.toggleClass('branch-radio-empty--warning', variant === 'warning');
      } else {
        $message.hide();
        $message.removeClass('branch-radio-empty--warning');
      }
    };

    const renderBranchCards = function(branches, userGroupSerialSource) {
      const branchArray = Array.isArray(branches) ? branches : [];
      $list.empty();
      branchArray.forEach((branch, index) => {
        $list.append(buildBranchCardElement(branch, index, branchFieldName, userGroupSerialSource));
      });
      const $newRadios = $list.find('input[type="radio"]');
      bindRadioCookiePersistence($newRadios);
      const savedBranch = loadValueFromCookies(branchFieldName);
      if (savedBranch) {
        $list.find(`input[type="radio"][value="${savedBranch}"]`).prop('checked', true);
      }
    };

    const fetchBranchesForCity = function(citySerial) {
      const serialValue = citySerial ? citySerial.toString().trim() : '';
      const products = $group.data('products') || '';
      const userGroupSerialSource = $group.data('user-group-serial-source') || '';
      const additionalQuery = $group.data('additional-query') || '';
      const tableName = $group.data('table-name') || '';
      const emptyMessage = $group.data('empty-message') || '';
      if (!serialValue) {
        $list.empty();
        showMessage(branchMessages.noCity);
        return;
      }
      showMessage(branchMessages.loading);

      path_url = '/api/v1/branches';
      if (window.location.host === 'app.ruangguru.com') {
        path_url = '/form/api/v1/branches';
      } else {
        path_url = '/api/v1/branches';
      }
      
      $.ajax({
        url: path_url,
        method: 'GET',
        data: { city_serial: serialValue, products: products, additional_query: additionalQuery,  table_name: tableName}
      }).done((response) => {
        if (response && response.status === 'error') {
          showMessage(branchMessages.error);
          $list.empty();
          return;
        }
        const branches = parseBranchResponse(response || {});
        if (branches.length === 0) {
          $list.empty();
          showMessage(emptyMessage !== '' ? emptyMessage : branchMessages.noBranch, 'warning');
          return;
        }
        renderBranchCards(branches, userGroupSerialSource);
        showMessage('');
      }).fail(() => {
        $list.empty();
        showMessage(branchMessages.error);
      });
    };

    $cityField.on('change', function() {
      fetchBranchesForCity($(this).val());
    });
    fetchBranchesForCity($cityField.val());

      branchGroupControllers.push({
        reset: () => {
          $list.empty();
          showMessage(branchMessages.noCity);
        }
      });
  });

  const $provinceField = $('[name="reward_form_submission[submission_data][address][province]"]');
  $provinceField.on('change', () => {
    branchGroupControllers.forEach((controller) => controller.reset());
  });
}

